/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
Buyapowa.Views.Splash = class Splash {
  constructor(el, controller) {
    this.onKeyPressed = this.onKeyPressed.bind(this);
    this.onButtonClick = this.onButtonClick.bind(this);
    this.termsOptInValid = this.termsOptInValid.bind(this);
    this.emailComplianceOptInValid = this.emailComplianceOptInValid.bind(this);
    this.marketingOptInValid = this.marketingOptInValid.bind(this);
    this.disableButton = this.disableButton.bind(this);
    this.enableButton = this.enableButton.bind(this);
    this.showTooltip = this.showTooltip.bind(this);
    this.hideTooltip = this.hideTooltip.bind(this);
    this.el = el;
    this.controller = controller;
    this.fullName = this.el.find('[data-input-tick="full_name"]');
    this.email = this.el.find('[data-input-tick="email"]');
    this.termsOptIn = this.el.find('[data-input-opt-in="terms"]');
    this.emailComplianceOptIn = this.el.find('[data-input-opt-in="email_compliance"]');
    this.marketingOptIn = this.el.find('[data-input-opt-in="marketing"]');
    this.marketingOptInOptional = this.marketingOptIn.data('optional');
    this.customField = this.el.find('[data-input-tick="custom-field"]');

    this.button = this.el.find('form').find('button.splash');

    this.email.tooltipster({
      position: 'bottom',
      content: ''
    });
    this.email.tooltipster('disable');
  }

  onKeyPressed(cb) {
    this.termsOptIn.on('change', cb);
    this.emailComplianceOptIn.on('change', cb);
    return this.marketingOptIn.on('change', cb);
  }

  onButtonClick(cb) {
    return this.button.on('click', cb);
  }

  termsOptInValid() {
    if (this.termsOptIn.length === 0) { return true; }
    return this.termsOptIn.find('input').is(':checked');
  }

  emailComplianceOptInValid() {
    if (this.emailComplianceOptIn.length === 0) { return true; }
    return this.emailComplianceOptIn.find('input').is(':checked');
  }

  marketingOptInValid() {
    if (this.marketingOptInOptional) { return true; }
    if (this.marketingOptIn.length === 0) { return true; }
    return this.marketingOptIn.find('input').is(':checked');
  }

  disableButton() {
    return this.button.attr('disabled','disabled');
  }

  enableButton() {
    return this.button.removeAttr('disabled');
  }

  showTooltip(text) {
    this.email.tooltipster('content', text);
    this.email.tooltipster('enable');
    return this.email.tooltipster('show');
  }

  hideTooltip() {
    this.email.tooltipster('disable');
    return this.email.tooltipster('hide', () => {
      return this.email.tooltipster('content', '');
    });
  }

  buttonProgressText() {
    return this.el.data('button-progress-text');
  }

  invalidEmailTooltip() {
    return this.el.data('invalid-email-tooltip');
  }
};
